import Field from '../Field.jsx';
import FieldGroup from '../FieldGroup.jsx';
import { NumInput, Toggle } from './primitives.jsx';

const TIER_KEYS = ['free', 'pro'];
const TIER_LABEL = { free: 'Free', pro: 'Pro' };

export default function ReferralsSection({ referral, set }) {
  const setR = (field, value) => set(`referral.${field}`, value);

  return (
    <div className="space-y-5">
      <section className="rounded-box border border-carbon-100 bg-white px-4 py-3 flex items-center justify-between gap-3">
        <div>
          <p className="label text-carbon-800">Referral program</p>
          <p className="caption text-carbon-400 mt-1">
            Hybrid: activation bonus + ongoing % share of referee spend, capped, tier-multiplied.
            Payouts in Pulsar Points.
          </p>
        </div>
        <Toggle
          checked={referral.enabled}
          onChange={(v) => setR('enabled', v)}
          ariaLabel="Toggle referral program"
        />
      </section>

      {referral.enabled && (
        <>
          <FieldGroup
            title="Activation bonus"
            caption="One-time on referee qualifying spend within the eligibility window"
          >
            <Field
              label="Referrer points"
              value={referral.activationBonus.referrerPoints}
              step={50}
              onChange={(v) => setR('activationBonus.referrerPoints', v)}
            />
            <Field
              label="Referee points"
              value={referral.activationBonus.refereePoints}
              step={50}
              onChange={(v) => setR('activationBonus.refereePoints', v)}
            />
            <Field
              label="Min qualifying spend ($)"
              value={referral.activationBonus.eligibilityMinSpendEur}
              step={10}
              onChange={(v) => setR('activationBonus.eligibilityMinSpendEur', v)}
            />
            <Field
              label="Eligibility window (days)"
              value={referral.activationBonus.eligibilityWindowDays}
              step={1}
              onChange={(v) => setR('activationBonus.eligibilityWindowDays', v)}
            />
          </FieldGroup>

          <FieldGroup
            title="Ongoing share"
            caption="% of referee monthly spend, paid as Points, decays out at duration end"
          >
            <Field
              label="Rate"
              value={referral.ongoing.rate}
              pct
              step={0.005}
              onChange={(v) => setR('ongoing.rate', v)}
            />
            <Field
              label="Duration (months)"
              value={referral.ongoing.durationMonths}
              step={1}
              onChange={(v) => setR('ongoing.durationMonths', v)}
            />
            <Field
              label="Monthly cap ($)"
              value={referral.ongoing.monthlyCapEur}
              step={100}
              onChange={(v) => setR('ongoing.monthlyCapEur', v)}
            />
          </FieldGroup>

          <div className="rounded-box border border-carbon-100 bg-white overflow-hidden">
            <div className="px-4 py-3 border-b border-carbon-100">
              <p className="label text-carbon-800">Tier multiplier</p>
              <p className="caption text-carbon-400 mt-1">
                Multiplier applied to all referral payouts based on referrer's tier
              </p>
            </div>
            <div className="px-4 py-4 grid grid-cols-3 gap-4">
              {TIER_KEYS.map((tk) => (
                <div key={tk}>
                  <p className="caption text-carbon-400 mb-1.5">{TIER_LABEL[tk]}</p>
                  <NumInput
                    value={referral.tierMultiplier[tk]}
                    step={0.1}
                    decimals={2}
                    onChange={(v) => setR(`tierMultiplier.${tk}`, v)}
                    ariaLabel={`${tk} multiplier`}
                  />
                </div>
              ))}
            </div>
          </div>

          <FieldGroup title="Behavioral assumptions" caption="Mean adoption among cardholders">
            <Field
              label="Adoption rate"
              value={referral.adoptionRate}
              pct
              step={0.01}
              onChange={(v) => setR('adoptionRate', v)}
            />
            <Field
              label="Avg successful referrals"
              value={referral.avgReferralsPerReferrer}
              step={0.5}
              decimals={1}
              onChange={(v) => setR('avgReferralsPerReferrer', v)}
            />
          </FieldGroup>
        </>
      )}
    </div>
  );
}
